// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-header {
    background-color: transparent !important;
}

.logo {
    position: relative;
    top: 0;
    left: 0;
}
.inputheight {
    height: auto !important;
}
.paddingleft {
    padding-left: 40px;
}

.paddingtop {
    padding-top: 40px;
}
.paddingtop10 {
    padding-top: 10px;
}

.paddingbottom10 {
    padding-bottom: 10px;
}

.is-invalid {
    border-left: solid 6px red;
}

.material-icons {
    display: inline-flex;
    vertical-align: middle;
}

.form-signin {
    max-width: 330px;
    padding: 15px;
}

@font-face {
    font-family: 'cabrion';
    src: url('Cabrion-Light.otf');
}
* {
    font-family: 'cabrion';
}
.login-wrapper {
    background: url('bg.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}

.login-card {
    padding: 100px 55px;
}

.fs-36 {
    font-size: 36px;
}
.fs-24 {
    font-size: 24px;
}

.fw-bold {
    font-weight: bold;
}
.text-gray {
    color: #a6a1b7;
}
.form-control {
    height: 55px;
    font-size: 18px;
}

.fs-14 {
    font-size: 14px;
}

.text-blue {
    color: #0f2d47;
}
.btn-blue {
    background-color: #0f2d47 !important;
    color: white !important;
    border-radius: 5px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

@media screen and (max-width: 1366.98px) {
    .login-wrapper {
        padding-top: 100px;
        padding-bottom: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .w-75 {
        width: 100% !important;
        margin: auto;
    }
    .logo {
        width: 200px;
        position: relative;
    }
    .login-card {
        padding: 50px 30px;
    }
}


.password-field-container {
    position: relative;

    .password-toggle {
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        color: #666;

        &:hover {
            color: #333;
        }

        i {
            font-size: 18px;
        }
    }
}

.fixed-bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: transparent;
    z-index: 999;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/login/login.component.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,6BAAgD;AACpD;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,yBAA6C;IAC7C,4BAA4B;IAC5B,sBAAsB;IACtB,2BAA2B;IAC3B,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI;QACI,kBAAkB;QAClB,qBAAqB;QACrB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;IACvB;IACA;QACI,sBAAsB;QACtB,YAAY;IAChB;IACA;QACI,YAAY;QACZ,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;AACJ;;;AAGA;IACI,kBAAkB;;IAElB;QACI,kBAAkB;QAClB,WAAW;QACX,QAAQ;QACR,2BAA2B;QAC3B,eAAe;QACf,WAAW;;QAEX;YACI,WAAW;QACf;;QAEA;YACI,eAAe;QACnB;IACJ;AACJ;;AAEA;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,6BAA6B;IAC7B,YAAY;AAChB;AACA,43JAA43J","sourcesContent":[".card-header {\n    background-color: transparent !important;\n}\n\n.logo {\n    position: relative;\n    top: 0;\n    left: 0;\n}\n.inputheight {\n    height: auto !important;\n}\n.paddingleft {\n    padding-left: 40px;\n}\n\n.paddingtop {\n    padding-top: 40px;\n}\n.paddingtop10 {\n    padding-top: 10px;\n}\n\n.paddingbottom10 {\n    padding-bottom: 10px;\n}\n\n.is-invalid {\n    border-left: solid 6px red;\n}\n\n.material-icons {\n    display: inline-flex;\n    vertical-align: middle;\n}\n\n.form-signin {\n    max-width: 330px;\n    padding: 15px;\n}\n\n@font-face {\n    font-family: 'cabrion';\n    src: url('../../assets/fonts/Cabrion-Light.otf');\n}\n* {\n    font-family: 'cabrion';\n}\n.login-wrapper {\n    background: url('../../assets/images/bg.png');\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n    min-height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.login-card {\n    padding: 100px 55px;\n}\n\n.fs-36 {\n    font-size: 36px;\n}\n.fs-24 {\n    font-size: 24px;\n}\n\n.fw-bold {\n    font-weight: bold;\n}\n.text-gray {\n    color: #a6a1b7;\n}\n.form-control {\n    height: 55px;\n    font-size: 18px;\n}\n\n.fs-14 {\n    font-size: 14px;\n}\n\n.text-blue {\n    color: #0f2d47;\n}\n.btn-blue {\n    background-color: #0f2d47 !important;\n    color: white !important;\n    border-radius: 5px;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n@media screen and (max-width: 1366.98px) {\n    .login-wrapper {\n        padding-top: 100px;\n        padding-bottom: 100px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n    .w-75 {\n        width: 100% !important;\n        margin: auto;\n    }\n    .logo {\n        width: 200px;\n        position: relative;\n    }\n    .login-card {\n        padding: 50px 30px;\n    }\n}\n\n\n.password-field-container {\n    position: relative;\n\n    .password-toggle {\n        position: absolute;\n        right: 12px;\n        top: 50%;\n        transform: translateY(-50%);\n        cursor: pointer;\n        color: #666;\n\n        &:hover {\n            color: #333;\n        }\n\n        i {\n            font-size: 18px;\n        }\n    }\n}\n\n.fixed-bottom {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background-color: transparent;\n    z-index: 999;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
